import DashboardView from '@/components/views/DashboardView.vue'
import ProjectSettingsView from '@/components/views/ProjectSettingsView.vue'
import ProjectChatsViewV2 from '@/components/views/ProjectChatsViewV2.vue'
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import UsersView from '@/components/views/UsersView.vue'
import ProjectsView from '@/components/views/ProjectsView.vue'
import EmptyDashboard from '@/components/views/EmptyDashboard.vue'
import AddOrEditUserModal from '@/components/users/AddOrEditUserModal.vue'
import AddOrEditProjectModal from '@/components/projects/AddOrEditProjectModal.vue'
import ErrorPageView from '@/components/views/ErrorPageView.vue'
import { ErrorName } from '@/enums.ts'
import { useMutation } from '@vue/apollo-composable'
import * as I from '@/components/users/interfaces.ts'
import { UnAuthorizeUserMutation } from '@/components/users/graphql/user.mutations.ts'
import SignInView from '@/components/views/SignInView.vue'
import ChatMessagesV2 from '@/components/chat/chatV2/ChatMessagesV2.vue'
import WelcomeView from '@/components/views/WelcomeView.vue'
import PlaygroundView from '@/components/views/PlaygroundView.vue'

const router: RouteRecordRaw[] = [
  { path: '/', component: WelcomeView },
  { path: '/analytics', component: EmptyDashboard },
  { path: '/oops/:errorName', component: ErrorPageView, props: true },
  { path: '/:projectKey/analytics', component: DashboardView },
  {
    path: '/projects',
    component: ProjectsView,
    children: [
      { path: 'add', name: 'add-project-modal', component: AddOrEditProjectModal },
      { path: ':projectId/edit', name: 'edit-project-modal', component: AddOrEditProjectModal },
    ]
  },
  {
    path: '/users',
    alias: ['/users'],
    component: UsersView,
    children: [
      { path: 'add', name: 'add-user-modal', component: AddOrEditUserModal },
      { path: ':userId/edit', name: 'edit-user-modal', component: AddOrEditUserModal }
    ]
  },
  {
    path: '/logout',
    component: SignInView,
    beforeEnter: async (to, from, next) => {

      console.log('beforeEnter | hehe')
      const { onDone, onError, mutate } = useMutation<{ status: I.StatusResponse }>(UnAuthorizeUserMutation)

      onDone((response) => {
        console.log('logout | onDone:', response.data)
        window.location.href = '/' // TODO: Maybe make better way?
        next()
      })

      onError((err) => {
        console.log('logIn | onError:', err)
      })

      await mutate()

      return false
    },
  },
  { path: '/:projectKey/settings', component: ProjectSettingsView },
  { path: '/:projectKey/playground', component: PlaygroundView },
  {
    path: '/:projectKey/chats',
    component: ProjectChatsViewV2,
    children: [
      {
        path: ':chatIndex',
        component: ChatMessagesV2,
        props: route => ({
          chatIndex: parseInt(route.params.chatIndex as string)
        })
      }
    ]
  },
  // Catch-all for 404
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: ErrorPageView,
    props: {
      errorName: ErrorName.NotFound
    }
  },
]

export function buildPathByErrorName(name: ErrorName) {
  return `/oops/${name}`
}

export default createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: router,
})

export enum RoutePath {
  Users = '/users'
}
